import { render, staticRenderFns } from "./CreateBespokeOrder.vue?vue&type=template&id=1c20eb88&"
import script from "./CreateBespokeOrder.vue?vue&type=script&lang=js&"
export * from "./CreateBespokeOrder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports